import { HttpClient } from "../helpers/HttpClient";

export const getInstallationFeedbackIsSent = async (hash: string) => {
    return await HttpClient({
        url: `/v2/feedbacks/${hash}/available`,
        method: "get",
        params: { hash },
    });
};

export const postInstallationFeedback = async (data: any) => {
    return await HttpClient({
        url: `/v2/feedbacks`,
        method: "post",
        data: data,
    });
};
